import { createActionType } from 'app/store/utils';

const type = createActionType('error');

export const FOREIGN_HTTP_ERROR = type('ForeignHTTPError');
export const CLEAR_ERROR = type('ClearError');
